import { PrzejscieModDescriptionEnum, PrzejscieModEnum } from 'api/strefy/strefy.enum';
import {
  PassagesEndZoneSortEnum,
  PassagesIdSortEnum,
  PassagesQueryKeysEnum,
  PassagesReaderNameSortEnum,
  PassagesStartZoneSortEnum,
  QueryKeyLocalStorageEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Table } from 'ui/table/Table';

export const PassagesTableHeader = () => {
  const { formatMessage } = useLocale();

  const modFilterOptions = Object.values(PrzejscieModEnum).map((mod) => ({
    name: formatMessage({ id: PrzejscieModDescriptionEnum[mod] }),
    filterBy: mod,
  }));

  return (
    <>
      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.PASSAGES}
        sortBy={PassagesIdSortEnum}
        queryHeader={formatMessage({ id: AppMessages['common.id'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.PASSAGES}
        sortBy={PassagesReaderNameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['definitions.passages.readerName'] })}
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.PASSAGES}
        queryName={PassagesQueryKeysEnum.MOD}
        filterItems={modFilterOptions}
        queryHeader={formatMessage({ id: AppMessages['definitions.passages.mod'] })}
        queryHeaderDescriptions={PrzejscieModDescriptionEnum}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.PASSAGES}
        sortBy={PassagesStartZoneSortEnum}
        queryHeader={formatMessage({ id: AppMessages['definitions.passages.startZone'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.PASSAGES}
        sortBy={PassagesEndZoneSortEnum}
        queryHeader={formatMessage({ id: AppMessages['definitions.passages.endZone'] })}
      />
    </>
  );
};
